import { render, staticRenderFns } from "./ViewHeader.vue?vue&type=template&id=625d2091"
import script from "./ViewHeader.ts?vue&type=script&lang=ts&external"
export * from "./ViewHeader.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports